/* @Author: liwen 
 * @Date: 2020-12-Su 05:05:56 
 * @Last Modified by:   liwen  */
import React from 'react';

class ColumnSetting extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    render(){
        return(
            <div>这里是栏目设置页面</div>
        )
    }
}

export default ColumnSetting